var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Scene',{attrs:{"debug":Boolean(_vm.query.debug),"environment":{
    createGround: false,
    createSkybox: false,
  }},on:{"scene":_vm.onSceneReady}},[_c('Entity',{attrs:{"scaling":[1, 1, 1],"rotation":[0, Math.PI, 0]}},[(_vm.modelUrl)?_c('Asset',{attrs:{"src":_vm.modelUrl},model:{value:(_vm.baseModel),callback:function ($$v) {_vm.baseModel=$$v},expression:"baseModel"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }